'use strict';

angular.module('agencyController', [])
.controller('AgencyController', ['appInfo', '$scope', '$rootScope', '$log', '$q', '$routeParams', 'AgencyService',
    function (appInfo, $scope, $rootScope, $log, $q, $routeParams, AgencyService) {    
    
    $rootScope.header.style = "collapse";
    $rootScope.header.show = false;
    $rootScope.loading = true;

    //Check auth credentials
    var currentUser = $rootScope.currentUser
    , ekey = currentUser.authdata
    , today = appInfo.today
    ;

    $scope.identifier = ($routeParams.identifier)? $routeParams.identifier : 0;
    $scope.agency = [];

    AgencyService.getListings($scope.identifier).then(function(response){ console.log(response);
        $scope.agency = response;
        $scope.agency.info.website = $scope.agency.info.website.replace(/(?:\r\n|\r|\n)/g, '<br />');
      }).finally(function(){
        $rootScope.loading = false;
    });

}]);